import {
  TransactionPaymentMethod,
  TransactionStatus,
  TransactionType,
} from '__generated__/GQL';

import { TaxForecastPeriodRevenueQueryVariables } from '../graphql/taxForecastPeriodRevenue.gql';

interface Params {
  transactionAfter: number;
  transactionBefore: number;
}

export type TransactionSumPartialFilters = Omit<
  TaxForecastPeriodRevenueQueryVariables['filters'],
  'bankAccountId'
>;

export const useTaxForecastPeriodRevenueQueryFilters = ({
  transactionAfter,
  transactionBefore,
}: Params): TransactionSumPartialFilters => {
  // Intra company funds transfer should not impact the revenue
  const allTransactionsExceptIntra = Object.values(
    TransactionPaymentMethod,
  ).filter(
    (value) => value !== TransactionPaymentMethod.IntraCompanyFundsTransfer,
  );

  return {
    isPersonal: false,
    paymentMethod: allTransactionsExceptIntra,
    status: TransactionStatus.Validated,
    transactionAfter,
    transactionBefore,
    type: TransactionType.Payin,
  };
};
